
export default {
  name: "IconNavigation",
  inheritAttrs: false,
};
